import { useSelector } from 'react-redux'

import { UserData } from 'models/Auth'
import { PARTICULAR_PLAN_GROUP_CODE } from 'settings/_planGroupCode'

export const useEnablePsychiatry = (): boolean => {
  const selectedPlan = useSelector((state: UserData) => state.auth.planSelected)
  const isSelectedPlanParticular = selectedPlan?.plan_group.code === PARTICULAR_PLAN_GROUP_CODE
  const isSelectedPlanEnablePsychiatryOrIsParticular = selectedPlan?.psychiatry_enabled || isSelectedPlanParticular

  if (isSelectedPlanEnablePsychiatryOrIsParticular) {
    return true
  }

  return false
}